import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Skycons from 'react-skycons';

const StyledWeatherTeaser = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

const StyledWeatherDay = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0.5rem;
  padding: 1rem;
  border: 4px solid black;
  box-sizing: border-box;
  color: black;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: -2px;

  canvas {
    max-width: 300px;
  }

  &:first-of-type {
    grid-column: 1/-1;
  }
`;

const StyledWeatherFullWidth = styled.div`
  grid-column: 1/-1;
`;

const propTypes = {
  weather: PropTypes.shape({
    currently: PropTypes.shape({
      apparentTemperature: PropTypes.number,
    }),
    daily: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({
        time: PropTypes.number,
        temperatureLow: PropTypes.number,
        temperatureHigh: PropTypes.number,
        icon: PropTypes.string,
      })),
    }),
  }),
};

const defaultProps = {
  weather: null,
};

/**
 * Convert the dark sky api name for the icons to a format that react-skycons can understand.
 *
 * @param {string} icon
 *
 * @returns {string}
 */
function convertDarkSkyIconNameToSkyCon(icon) {
  if (typeof icon !== 'string') {
    return 'CLEAR_DAY';
  }
  return icon.toUpperCase().replace(/-/g, '_');
}

function WeatherTeaser({ weather }) {
  const weatherIconColor = 'black';

  return (
    <StyledWeatherTeaser>
      {weather.currently && (
        <StyledWeatherDay>
          {
            <React.Fragment>
              <h3>
                Temperature:
                {weather.currently.apparentTemperature}
                &deg;
              </h3>
              <Skycons
                color={weatherIconColor}
                icon={convertDarkSkyIconNameToSkyCon(weather.currently.icon)}
                autoplay
              />
            </React.Fragment>
          }
        </StyledWeatherDay>
      )}

      {weather.daily && weather.daily.data && weather.daily.data.map(day => (
        <StyledWeatherDay key={day.time}>
          <StyledWeatherFullWidth>
            <span className="weather--forecast--day--name">
              {new Date(day.time * 1000).toLocaleString('en-US', { timeZone: 'America/Toronto', weekday: 'long' })}
            </span>
          </StyledWeatherFullWidth>
          <span className="weather--forecast--day--low">
            {day.temperatureLow}
            &deg;
          </span>
          <span className="weather--forecast--day--high">
            {day.temperatureHigh}
            &deg;
          </span>
          <StyledWeatherFullWidth>
            <Skycons
              color={weatherIconColor}
              icon={convertDarkSkyIconNameToSkyCon(day.icon)}
              autoplay
            />
          </StyledWeatherFullWidth>
        </StyledWeatherDay>
      ))}
    </StyledWeatherTeaser>
  );
}

WeatherTeaser.propTypes = propTypes;
WeatherTeaser.defaultProps = defaultProps;

export default WeatherTeaser;



// WEBPACK FOOTER //
// ./src/Components/WeatherTeaser/index.jsx